<template>

    <!-- 今日上新的课程列表 -->
    <div class="page white_bg" style="max-width: 425px;">

        <header class="pageHeader white_bg" style="line-height: 30px;">
            <div class="borderLayout paddingH16 paddingV8">
                <div class="middleRegion">
                    <div class="westRegion" style="width: 60px">
                        <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;" @click="back();"></span>
                    </div>
                    <div class="centerRegion alignCenter font18r primaryTextColor bold"
                         style="height: 30px; overflow: hidden">
                        {{title}}
                    </div>
                    <div class="eastRegion font14r alignRight" style="width: 60px"
                        data-explain="本来是跳转到统一的搜索页，但现产品经理硬要在当前页进行搜索，颠覆原有规划。">
                        <i class="icon searchIcon" style="margin-top: 3px;" @click="$refs.searchBar.show()"></i>
                    </div>
                </div>
            </div>
        </header>

        <searchBar ref="searchBar" @search="onSearch"/>

        <div class="body" style="">
            <div class="white_bg" style="border-radius: 16px 16px 0px 0px;">

                <div class="tabModule hiddenScrollbar" style="overflow: auto">
                    <div class="moduleHeader clearfix paddingH16" style="padding-top: 14px;"
                        :style="'width: ' + 88 * (tabModule.list.length + 1) + 'px'">
                        <div class="tabItem" :class="{active : tabModule.activeItem === null}"
                             @click="tabModule.activeItem = null; tabModule.activeIndex = 0;
                                onChangeCategory(null)">
                            全部
                        </div>
                        <div class="tabItem" :class="{active : tabModule.activeItem === tabItem}"
                             v-for="(tabItem, index) in tabModule.list" :key="tabItem.id"
                             @click="tabModule.activeItem = tabItem; tabModule.activeIndex = index;
                            onChangeCategory(tabItem)">
                            {{tabItem.name}}
                        </div>
                    </div>
                </div>

                <!-- 广告图 -->
                <div class="generalPagePaddingH" style="margin-top: 12px;">
                    <bannerModule4 :itemCount="99" version="4" categoryKey="AUTHENTICATED_COURSE_PAGE" />
                </div>

                <div class="dataList" >
                    <div class="dataRow flexLayout" v-for="(dataItem, index) in dataList"
                         :key="dataItem.id" @click="viewItem(dataItem)">
                        <div class="width: 124px;">
                            <div class="imageArea roundBorder8 hiddenOverflow w100p"
                                 style="width: 124px;height: 78px;">
                                <img class="fullSpace cover" :src="dataItem.coverImg"
                                     v-if="dataItem.coverImg"/>
                            </div>
                        </div>
                        <div class="flexItem marginL12">
                            <div class="lineHeight21r14f bold font14r grey20 hiddenOverflow" style="
                                max-height: 3em;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;">
<!--                                <i class="icon authenticatedIcon"></i>-->
                                {{dataItem.title}}
                            </div>
                            <div class="font12r grey marginT12">
                                {{dataItem.teacherName}}
<!--                                | 师讯首席讲师-->
                            </div>
                            <div class="bold grey20 marginT12 clearfix" style="line-height: 23px;">
                                <div class="fl">
                                    <strong class="red" v-if="dataItem.chargeMode == 'FREE'">免费</strong>
                                    <template v-else>
                                        <strong class="font12r red">￥</strong>
                                        <strong class="red">{{dataItem.price}}</strong>
                                    </template>
                                    <span class="marginL4 grey20 font12r"
                                          v-show="dataItem.liveCount > 0">/共{{dataItem.liveCount}}节</span>
                                </div>
                                <div class="fr grey font12r" style="padding-top: 2px;">
                                    {{dataItem.applicantCount + dataItem.applicantCountSham}}人在学
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="alignCenter paddingV8" v-show="status === 'loading'">
                        <i class="icon spinner-loader"></i>
                    </div>

                    <div class="paddingV16 colorCCC font14r alignC"
                         v-show="status == 'ready' && dataList.length < 1">
                        暂无任何课程
                    </div>

                    <div class="paddingV16 alignCenter font14r colorCCC"
                         v-show="status=='ready' && pagination.current == pagination.totalPage"
                         :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                        没有更多课程了
                    </div>

                    <div class="paddingV16 colorCCC font14r alignC"
                         v-show="status == 'error'">
                        加载数据失败
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import shixunPagePart from '../shixunApp/shixunPagePart';

// config
import appConfig from '@/appConfig';

// api
import courseApi    from '@/components/vodCourse/vodCourseApi';
import consoleApi   from '../platformApi/consoleApi';

// modules
import searchBar        from "../search/searchBar";
import bannerModule4    from '../ad/bannerModule4';

// util
import appHelper        from '@/util/appHelper';

// 认证课程其实就是一个标记而已，相当于自评的优质课程
const config = {
    name : 'authenticatedCoursePage',
    title : '教资服务',  // 旧标题：学历教资
    description : appConfig.name + ' - ' + appConfig.desc,
    note : '考证服务页面，就是以前的认证课程页面，展示的是带认证标签的视频点播课。',
    apiConfig : {
        list : {
            url : 'portal/courseVod/listForAudience',
            params:{
                isCertification : true,
                categorySecondId:'',
                categoryFirstId:''
            },
            dataPath : 'data.rows',
            totalPath : 'data.totalCount',
            totalPagePath : 'data.totalPage',
            dataColumnMapping : {
                // userName : 'name''
            }
        }
    }
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : { searchBar, bannerModule4 },
    data () {
        return {
            title : config.title,
            description : config.description,
            note : config.note,
            pageKey: 'rzcourses-list',
            apiConfig : config.apiConfig,
            enableDataList : true,
            autoLoadDataList : appConfig.mode != 'demo',

            tabModule : {
                list : [
                // {
                //     'topicName' : '热门课程'
                // },{
                //     'topicName' : '入园管理'
                // }
                ],
                activeIndex : 0,
                activeItem : null
            },

            searchInputbox : {
                column : 'title'
            }
        }
    },
    methods : {

        viewItem(dataItem) {
            appHelper.goToPage('courseDetail', {
                id : dataItem.id
            });
        },

        onChangeKeywords() {
            this.search();
        },

        search() {
            let value = this.$refs.searchInputbox.value;
            this.onSearch(value);
        },

        onChangeCategory(category) {
            if (category)
            {
                // 认证课程是一级分类，显示出来的是二级分类
                this.apiConfig.list.params.categorySecondId = category.id;
            }
            else
            {
                delete this.apiConfig.list.params.categorySecondId;
            }

            this.reloadDataList();
        }
    },
    mounted() {

        consoleApi.log('[authenticatedCoursePage] ' + config.note);

        courseApi.getCategoryList({
            isCertification : true
        }, (list) => {

            if (list.length)
            {
                this.apiConfig.list.params.categoryFirstId = list[0].id;
                this.tabModule.list = list[0].childsList;
            }

        });
    }
}
</script>

<style lang="scss" scoped>
.lightGrey {
    color: hsla(219, 16%, 60%, 1);
}
.grey {
    color: hsla(219, 9%, 39%, 1);
}
.searchIcon {
    width: 18px;
    height: 19px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAmCAYAAABDClKtAAADVklEQVRYhcWYT4jVVRTHb00DNgYiuRUXuhAdH9zz+d6hgSf8RKQhGC3ih2U7CSIIhEJdBEK0qFaKKBptBLFoIWYgLRKhiGgSUjcTiFhBQfindPUGG2dczHvTnTu/9+b9Zt6fA2fx3r3nnM895/7uP+dKSJ7nA977ncAHkr6RdBuoAbPAbP33FUlHzewVYLCM/1ICrAM+BO40ANpRM5uS9CmwuZMwQ8CRMiAt9DNg3YqAJA0Dv7YI8kDSz5IuRnoV+LOFzUNJu5YFZGZjZjZV5BQ4I2lkCftNko4CfzSBe9s593SZDO0pcDIl6USWZavKDtB7f7g+mNTngbYcmFklzZCZ/SbJl4WJpVqtrgV+KfgQ9rY0BNYAtxPDyeVkp0WMr9Kv08w2NTWQ9EmaoU4CRXF+TOJczrLsmUUdQwjrC+bQikrWTEZHR59N1ztJe4roTyRQx7oB1BBgHzATxbuxoEOWZauSyf2wG2UrALuWZOv/ykh6NcnSmW4D1eO+k0AdiomPJ40tF8ZOCjAdxf4hJv4uLl2vgOpQ16PYNefcU42G36MsXe0x1KW4SiGE9Y2GeD5d6THUuTi+937DIihJX/cTysxwzjlnZv/2sXyfNytffGb6q5dQki7HUPPrY0I7MzIy8nyvoIC/o9i34oYDSQrf6wWQmW1PPrKT843e+y3JZO/JvJJ0MYF6eUEH4Ke4hJJe6iYQc7ej/+KFc9HxpWD/u9lNKEnfJtU5uKhTnucD9ZtIvGZ80SWgQ8mxpQasKexsZi8k2ZqR9H4ngUIIe4FHSZZeX2oUBxOwaeBUJ4CAN1Mg4Fye5wNLGQ5KOp0YzgITK1m/zOy8pOnE57VKpbK63RENAV8WgNWAC+3CjY+PD5nZSeBBga9Z4D5l3hiAQeDjJs4eAzfM7Kyk/ZKGG+q9fw04Bkyw8ADXTO9577e0Deacc2b2YrIVrERrkvYD/yT/3w0hbC0FVqlUVgPvxqeJZehH1Wp1rXPzO8j9FEzScCkw5+ZuPSGEcUnniR7KWuglM3sjy7LnUl8hhK3AvaT/HWBbabCG5Hk+AGwMIYxJ2i3pLe/97hDCmJlVXBsvKvWnprspWN2+fwJsKwD7vq9Qzs299LDwGj/Zbybn3DzYBDAJ7HgCwHW6Z9xb1m4AAAAASUVORK5CYII=');
}
.authenticatedIcon {
    width: 44px;
    height: 13px;
    background-image: url('data:image/png;base64,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');
}
.tabModule {
    .tabItem {
        float: left;
        font-size: 14px;
        color: hsla(0, 0%, 20%, 1);
    }
    .tabItem:nth-child(n+2) {
        margin-left: 24px;
    }
    .tabItem.active {
        font-size: 16px;
        font-weight: bold;

        &:after {
            content: '';
            display: block;
            width: 24px;
            height: 3px;
            margin: 6px auto 0;
            background: #FFBC3B;
            border-radius: 2px;
        }
    }
}
.dataList {
    .dataRow {
        padding: 21px 16px 11px;
    }
}
</style>
